import EmojiSelector from '../components/common/emoji-selector.vue';
import CreateChannelView from '../helpers/createChannelForm';

const OnboardingForm = {
    components: {
        EmojiSelector
    },
    data() {
        return {
            message_body: `Wow, this is my first message sent through ${this.$global.product_name} ! 🔥🔥🔥🙌`,
            submitting: false,

            activeTab: 0
        }
    },
    props: [
        'phone',
        'origin'
    ],
    template: `
        <div>

            <form @submit.prevent="handleSubmit">
                <div class="modal-card" style="width: auto">
                    <header class="modal-card-head">
                        <p class="modal-card-title">Welcome {{ this.$store.getters.userProfile.first_name }}!</p>
                    </header>
                    <section class="modal-card-body">
                        <b-tabs v-model="activeTab" type="is-boxed" :animated="false" class="modal-tabs-invisible">
                            <b-tab-item>
                                <template slot="header"  style="visibility: hidden">
                                    <!--<b-icon icon="information-outline"></b-icon>-->
                                    <!--<span> Issues <b-tag rounded> 3 </b-tag> </span>-->
                                </template>
                                <div class="columns">

                                    <div class="column is-1">
                                        <svg class="pname-logo" viewBox="0 0 100 88" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                            <g id="Logo" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                                <g id="LOGO" transform="translate(-1231.000000, -1217.000000)">
                                                    <g id="Avatar-hollow" transform="translate(1231.000000, 1217.000000)">
                                                        <path d="M53.4444444,31 L92.8164062,15.5898438" id="Line" class="pname-logo-face" stroke-width="13" stroke-linecap="round"></path>
                                                        <path d="M53.4444444,81 L92.8164063,65.5898438" id="Line" class="pname-logo-face" stroke-width="13" stroke-linecap="round" transform="translate(73.130425, 73.294922) scale(1, -1) translate(-73.130425, -73.294922) "></path>
                                                        <path d="M53.4444444,48 L85.2222222,48" id="Line" class="pname-logo-face" stroke-width="13" stroke-linecap="round"></path>
                                                        <path d="M7.409375,21.4054687 L9.0265625,21.4054687 L9.0265625,12.5648437 C9.0265625,10.1929569 9.0894525,8.33320986 9.21523437,6.98554687 C9.34101625,5.63788389 9.69140337,4.4789111 10.2664062,3.50859375 C10.8414091,2.50233872 11.6679634,1.68476877 12.7460937,1.05585937 C13.8242241,0.42694998 15.0281184,0.1125 16.3578125,0.1125 C18.2265718,0.1125 19.9156175,0.813274242 21.425,2.21484375 C22.431255,3.14922342 23.0691393,4.29022764 23.3386719,5.63789062 C23.6082045,6.98555361 23.7429687,8.89920635 23.7429687,11.3789062 L23.7429687,21.4054687 L29.1335937,21.4054687 C31.2179792,21.4054687 32.8081976,21.8996044 33.9042969,22.8878906 C35.0003961,23.8761768 35.5484375,25.142961 35.5484375,26.6882812 C35.5484375,28.6648536 34.7668047,30.0484335 33.2035156,30.8390625 C31.6402266,31.6296915 29.4031396,32.025 26.4921875,32.025 L23.7429687,32.025 L23.7429687,59.0859375 C23.7429687,61.385949 23.8238273,63.1558532 23.9855469,64.3957031 C24.1472664,65.6355531 24.5785121,66.641793 25.2792969,67.4144531 C25.9800816,68.1871132 27.1210858,68.5734375 28.7023437,68.5734375 C29.5648481,68.5734375 30.7328051,68.4207047 32.20625,68.1152344 C33.6796949,67.8097641 34.8296834,67.6570312 35.65625,67.6570312 C36.8421934,67.6570312 37.9113234,68.1331984 38.8636719,69.0855469 C39.8160204,70.0378954 40.2921875,71.2148367 40.2921875,72.6164062 C40.2921875,74.9882931 38.9984504,76.8031187 36.4109375,78.0609375 C33.8234246,79.3187563 30.1039305,79.9476562 25.2523437,79.9476562 C20.6523207,79.9476562 17.1664181,79.1750077 14.7945312,77.6296875 C12.4226444,76.0843673 10.8683631,73.9461074 10.1316406,71.2148437 C9.39491819,68.4835801 9.0265625,64.8359603 9.0265625,60.271875 L9.0265625,32.025 L7.0859375,32.025 C4.9656144,32.025 3.34844307,31.52188 2.234375,30.515625 C1.12030693,29.50937 0.56328125,28.2336015 0.56328125,26.6882812 C0.56328125,25.142961 1.14725979,23.8761768 2.31523437,22.8878906 C3.48320896,21.8996044 5.18123886,21.4054687 7.409375,21.4054687 Z" id="t" class="pname-logo-face"></path>
                                                    </g>
                                                </g>
                                            </g>
                                        </svg>
                                    </div>

                                    <div class="column is-10">
                                        <p>
                                            Thank you for signing up for {{ this.$global.product_name }}, <b>The relationship-based WhatsApp marketing tool</b>.
                                        </p>
                                        <p>
                                            Dive right in by sending your first WhatsApp message below and check your phone 😎 !
                                        </p>
                                        <hr>

                                        <b-field label="Phone">
                                            <b-input :value="phone" minlength="4" maxlength="32" size="is-medium" required disabled></b-input>
                                        </b-field>

                                        <b-field label="Message">
                                            <b-input v-model="message_body" ref="message_body" maxlength="500" type="textarea"></b-input>
                                        </b-field>

                                        <emoji-selector @click="message_body += $event"></emoji-selector>

                                    </div>
                                    <div class="column is-1">
                                    </div>
                                </div>
                                <hr>
                                <div class="columns" style="width: 100%">
                                    <div class="column is-12 has-text-centered">
                                        <button type="submit" class="button is-primary is-medium" v-bind:class="{'is-loading': submitting}">Send test message to myself</button>
                                        <button class="button is-medium" type="button" @click="cancel">Not now!</button>
                                    </div>
                                </div>

                            </b-tab-item>

                            <b-tab-item>
                                <template slot="header">
                                    <!--<b-icon icon="source-pull"></b-icon>-->
                                    <!--<span> Pull Requests <b-tag rounded> 1 </b-tag> </span>-->
                                </template>
                                <h1 class="has-text-centered">Awesome! 😎</h1>
                                <h2 class="has-text-centered">
                                    You just sent your first message with {{ this.$global.product_name }}.
                                </h2>
                                <hr>
                                <p>
                                     This is the first step to get you ready to send campaigns to all your opted in contacts.
                                </p>
                                <br>
                                <p>
                                    Please follow the virtual tour to learn the basics of {{ this.$global.product_name }}. It will take only a minute, promise 🙏
                                </p>
                                <br>
                                <hr>

                                <div class="columns" style="width: 100%">
                                    <div class="column is-12 has-text-centered">
                                        <button type="button" class="button is-primary is-medium" @click="$emit('start-tour'); $parent.close()">Start tour</button>
                                    </div>
                                </div>

                            </b-tab-item>
                        </b-tabs>


                    </section>
                    <footer class="modal-card-foot">



                    </footer>
                </div>
            </form>
        </div>
        `,
    methods: {
        handleSubmit() {

            this.submitting = true;

            const params = {
                body: this.message_body,
                phone: this.phone,
                origin: this.origin,
                // attachment_url: 'https://i.giphy.com/media/3otPoS81loriI9sO8o/giphy.mp4',
                // attachment_mime_type: 'video/mp4'
                attachment_url: 'https://'+this.$global.hostname+'/assets/onboarding/textpop-welcome-splash.mp4',
                attachment_mime_type: 'video/mp4'
            };

            this.$store.dispatch('sendTestMessage', params).then((data) => {
                // console.log(data);

                this.$buefy.toast.open({
                    message: 'Message successfully sent!',
                    type: 'is-success'
                });

                this.createChannelModal('onboarding-test-message-sent');

                // // switch tab
                // this.activeTab = 1;

            }).catch((err) => {
                this.$buefy.toast.open({
                    message: 'Error occurred while sending message: '+this.$utils.getHumanErrorMessage(err),
                    type: 'is-danger'
                });
                // handle error
            }).finally(() => {
                this.submitting = false;
                // this.cancel();
            });
        },
        cancel() {

            // close this modal
            this.$parent.close();

            // show create Channel Modal
            setTimeout(() => {
                this.createChannelModal('onboarding-test-message-skipped');
            }, 1000);

        },
        createChannelModal(source) {

            // prevent from showing the onboarding process after page refresh
            this.$store.dispatch('finishOnboarding', {}).then((data) => { });

            // start the tourTo send message from your own number
            this.$emit('start-tour');

            // close this modal
            this.$parent.close();

            this.$buefy.modal.open({
                parent: this,
                component: CreateChannelView,
                hasModalCard: true,
                props: {
                    source: source
                }
            })
        },
    },
    mounted() {
        this.$refs.message_body.focus();
    }
}

export default OnboardingForm;
